import React, { useState, useEffect } from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
// @material-ui/core components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  IconButton,
  Icon,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@material-ui/core";
// @material-ui/styles
import styles from "../../../../../assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { LOCALE } from "../../../../../properties/Locale";
import EntityMetadata from "../../../../../common/components/EntityMetadata";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  triggerRerender,
} from "../../../../../common/actions/CommonActions";
import Card from "../../../../../common/components/Card/Card.js";
import CardHeader from "../../../../../common/components/Card/CardHeader.js";
import CardBody from "../../../../../common/components/Card/CardBody.js";
import { AuthorshipTypeRepository } from "./AuthorshipTypeRepository";
import { validateCreateForm } from "../../Validations";

const useStyles = makeStyles(styles);

export default function AuthorshipTypeEditComponent(props) {
  const classes = useStyles();
  const [authorshipTypeId] = useState(props.match.params.authorshipTypeId);
  const [redirectTo, setRedirectTo] = useState();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit: editAuthorshipTypeForm,
    register: registerEditForm,
    errors: errorsEditAuthorshipType,
    setValue,
    getValues,
    control,
  } = useForm(
    { validationSchema: validateCreateForm },
    {
      defaultValues: { active: false },
    }
  );
  const dispatch = useDispatch();
  let { gradingSchemaId } = useParams();

  useEffect(() => {
    loadAuthorshipType(authorshipTypeId);
  }, []);

  const showLoadingBar = () => {
    setLoading(true);
    setBtnSubmitLoading(true);
  };

  const hideLoadingBar = () => {
    setLoading(false);
    setBtnSubmitLoading(false);
  };

  const onEditAuthorshipType = (values) => {
    showLoadingBar();
    AuthorshipTypeRepository.update(values)
      .then((res) => {
        hideLoadingBar();
        dispatch(triggerRerender());
        dispatch(
          notifyShowSuccessMessage(
            LOCALE.authorship_type_update_success_message
          )
        );
        setRedirectTo(
          `/app/configuration/gradingSchema/${gradingSchemaId}/edit`
        );
      })
      .catch((err) => {
        hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  const loadAuthorshipType = (id) => {
    showLoadingBar();
    AuthorshipTypeRepository.fetch(id).then((res) => {
      Object.keys(res.data).map(function (item) {
        if (Object.keys(getValues()).indexOf(item) == -1) {
          registerEditForm({ name: item, type: "custom" });
        }
      });
      Object.entries(res.data).map(function (item) {
        setValue(item[0], item[1]);
      });
      hideLoadingBar();
    });
  };

  const handleClose = () => {};
  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Card>
        <Dialog
          open={true}
          onClose={handleClose}
          maxWidth="md"
          fullWidth={true}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {LOCALE.authorship_type_edit}
              <Link
                to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            {loading ? <LinearProgress color="secondary" /> : ""}
            <div>
              <form onSubmit={editAuthorshipTypeForm(onEditAuthorshipType)}>
                <DialogContent>
                  <TextField
                    id="name"
                    label={LOCALE.name}
                    error={errorsEditAuthorshipType?.name}
                    helperText={errorsEditAuthorshipType?.name?.message}
                    size="small"
                    fullWidth={true}
                    margin="normal"
                    variant="outlined"
                    name="name"
                    inputRef={registerEditForm}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      disabled: btnSubmitLoading,
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Controller
                        as={<Checkbox />}
                        control={control}
                        name="active"
                      />
                    }
                    label={LOCALE.active}
                  />

                  <EntityMetadata data={getValues()} />
                </DialogContent>
                <DialogActions>
                  {!btnSubmitLoading && (
                    <Link
                      to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                      style={{ textDecoration: "none" }}
                    >
                      <Button size="small" variant="outlined" color="secondary">
                        {LOCALE.cancel}
                      </Button>
                    </Link>
                  )}
                  <Button
                    type="submit"
                    size="small"
                    variant="contained"
                    disabled={btnSubmitLoading}
                    className={btnSubmitLoading ? "btn-loading" : ""}
                    color="primary"
                  >
                    {LOCALE.save}
                    {btnSubmitLoading && (
                      <CircularProgress
                        color="secondary"
                        size={20}
                        style={{ position: "absolute" }}
                      />
                    )}
                  </Button>
                </DialogActions>
              </form>
            </div>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
